var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectPopper',_vm._g(_vm._b({attrs:{"value":_vm.value,"options":_vm.speedArr}},'SelectPopper',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }